import { sectionsType } from './options';

export const getIsAllowedStage = (step: number, stage: string | null): boolean => {
  if (!stage) {
    return false;
  }
  const getStep = sectionsType.find(item => item.id === step);
  return stage === getStep?.allowStage;
};
